import {
  Inject,
  Injectable,
  InjectionToken,
  Optional,
  signal,
  WritableSignal,
} from '@angular/core';

export type AppTypes = 'main' | 'embed' | 'client' | '';

export const APP_TYPE = new InjectionToken<AppTypes>('');
export const TENANT_ID = new InjectionToken<string>('');

@Injectable({
  providedIn: 'root',
})
export class AppTypeService {
  #type: WritableSignal<AppTypes> = signal('');
  type = this.#type.asReadonly();

  #domain = signal('');
  domain = this.#domain.asReadonly();

  #tenantId = signal('');
  tenantId = this.#tenantId.asReadonly();

  constructor(
    @Inject(APP_TYPE) @Optional() type?: AppTypes,
    @Inject(TENANT_ID) @Optional() tenantId?: string
  ) {
    if (type) {
      this.#type.set(type);
    }

    if (tenantId) {
      this.#tenantId.set(tenantId);
    }
  }

  setType(type: AppTypes) {
    this.#type.set(type);
  }

  setDomain(domain: string) {
    this.#domain.set(domain);
  }

  setTenantId(tenantId: string) {
    this.#tenantId.set(tenantId);
  }
}
